<template>
  <div class="devInfo">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding:10px 20px;">
      <el-breadcrumb-item :to="{ path: '/admin/devinfo' }">用户详情</el-breadcrumb-item>
      <el-breadcrumb-item>编辑客户</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_wrapper">
      <div class="content__wrapper">
        <div class="accountKey info_item">
          <div style="font-size: 18px;font-weight: bold">开发者账号信息</div>
          <div class="info_form">
            <div class="info">
              <div class="info_label" >clientId：</div> <div class="info_content">{{companyInfo.clientId}}</div>
            </div>
            <div class="info">
              <div class="info_label">clientSecret：</div> <div class="info_content">{{companyInfo.clientSecret}}</div>
              <!-- <el-button type="primary" v-if="false">重置</el-button> -->
            </div>
            <div class="info">
              <div class="info_label" >用户ID：</div> <div class="info_content">{{companyInfo.id}}</div>
            </div>
            <div class="info">
              <div class="info_label">用户：</div> <div class="info_content">{{companyInfo.mobile}}</div>
              <!-- <el-button type="primary" v-if="false">重置密码</el-button> -->
            </div>
          </div>
        </div>
      </div>
        <div class="companyInfo info_item">
          <div style="font-size: 18px;font-weight: bold">公司基本信息</div>
          <div class="info_form">
            <el-form ref="companyInfo" :model="companyInfo" :rules="rules"  label-width="140px">
              <el-form-item label="公司全称"  class="is-required"   prop="companyName">
                <el-input v-model.trim="companyInfo.companyName" maxlength="64" placeholder="请输入公司全称..."></el-input>
              </el-form-item>
              <el-form-item label="联系人"  class="is-required"   prop="businessContact">
                <el-input v-model.trim="companyInfo.businessContact" maxlength="30" placeholder="请输入联系人..."></el-input>
              </el-form-item>
              <el-form-item label="联系电话"  class="is-required" prop="contactNumber">
                <el-input v-model.trim="companyInfo.contactNumber" maxlength="13" placeholder="请输入联系电话..."></el-input>
              </el-form-item>
              <el-form-item label="公司地址"   >
                <el-input v-model.trim="companyInfo.companyAddress" maxlength="200" placeholder="请输入公司地址..."></el-input>
              </el-form-item>
              <el-form-item label="公司网址"   >
                <el-input v-model.trim="companyInfo.companyWebsiteAddress" maxlength="200" placeholder="请输入公司网址..."></el-input>
              </el-form-item>
              <el-form-item label="营业执照号"   >
                <el-input v-model.trim="companyInfo.businessLicenseNumber" maxlength="32" placeholder="请输入营业执照号..."></el-input>
              </el-form-item>
              <el-form-item label="营业执照"   >
                <el-input v-model.trim="companyInfo.businessLicenseUrl" readonly></el-input><img class="businessLicense" v-if="companyInfo.businessLicenseUrl" :src="companyInfo.businessLicenseUrl" preview="0" preview-text="营业执照" title="查看营业执照"/>
                <el-upload
                  class="upload-demo"
                  :action="COMMON_UPLOAD_API"
                  :on-success="handleSuccess"
                  :headers="headers"
                  :on-remove="handleRemove"                  
                  :before-upload="uploadHandle_before"
                  :file-list="fileList"
                  accept=".jpg,.png"
                  list-type="picture">
                  <el-button size="small" type="primary">{{companyInfo.businessLicenseUrl?'更新营业执照':'上传营业执照'}}</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过10M</div>
                </el-upload>
              </el-form-item>
              <el-form-item size="large" style="text-align: center;">
                <el-button type="primary" v-loading="loading" @click="submit()">提交</el-button>
                <!-- <el-button type="info" @click="backLastPage()">返回</el-button> -->
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import types from '@/vuex/mutation-types'
import { mapMutations, mapGetters } from 'vuex'
import devService from '@/service/devService'
import {
  COMMON_UPLOAD_API
} from '@/resource/index'
export default {
  data () {
    return {
      loading: false,
      height: this.SysConstant.winHeight - 450,
      fileList: [],
      COMMON_UPLOAD_API: COMMON_UPLOAD_API,
      headers: {
        Authorization: this.$cookie.get('token')
      },
      rules: {
        companyName: [
          {required: true, message: '请输入公司名称', trigger: ['blur', 'change']}
        ],
        businessContact: [
          {required: true, message: '请输入联系人', trigger: ['blur', 'change']}
        ],
        contactNumber: [
          {required: true, message: '请输入联系电话', trigger: ['blur', 'change']},
          {validator: this.$rules.telephoneNumber, trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
    this.uploadText = '更新营业执照'
  },
  computed: {
    ...mapGetters(['companyInfo'])
  },
  methods: {
    ...mapMutations({
      commitCompanyInfo: types.COMPANY_INFO
    }),
    // 加载初始化数据
    submit () {
      this.loading = true
      this.$refs.companyInfo.validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            let data = await devService.devModifyInfo(this.companyInfo.id, this.companyInfo)
            // 同步更新Vuex
            this.commitCompanyInfo(this.companyInfo)
            this.$message.success(this.SysConstant.success)
            this.loading = false
            // this.$router.push({name: 'devInfo'})
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
      })
      this.loading = false
    },
    backLastPage () {
      this.$router.push({name: 'devmanage'})
    },
    handleRemove (file, fl) {
      this.fileList = []
      this.companyInfo.businessLicenseUrl = ''
    },

    uploadHandle_exceed(files, fileList){
      this.$message.error('请先删除再上传')
    },
    
    /* 上传之前校验 */
    uploadHandle_before(file) {  
      // 格式
      let ext = file.name.substring(file.name.lastIndexOf('.')+1) 
      if (['jpg','png'].indexOf(ext.toLowerCase())==-1) {
          this.$message.error('上传图片格式错误!');
          return false;
      }
      // 大小
      if (file.size / (10 * 1024 * 1024) > 1) {
          this.$message.error('上传图片大小不得超过10M!');
          return false;
      }
      
      return true;
    },
    handleSuccess (response, file, fileList) {
      this.fileList = []
      this.fileList.push(file)
      this.$set(this.companyInfo, 'businessLicenseUrl', response.data)
    }
  }
}
</script>
<style scoped>

  .devInfo {
    padding-top: 10px;
  }
  .devInfo .content_wrapper{
    padding-left: 20px;
    padding-right: 10px;
    background-color: #ffffff;
    padding-top: 20px;
  }

  .devInfo .toolbar .el-select {
    width: 130px;
  }
  .devInfo .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .devInfo .content_wrapper{
    width: 100%;
    height:100%;
  }
  .devInfo .content_wrapper .content__wrapper{
      background: #ffffff;
      width: 100%;
      height: 100%;
      margin:10px;
  }
  .devInfo   .content_wrapper .info_item{
    padding-left: 10px;
    padding-bottom: 10px;
    padding-right: 20px;
  }
  .devInfo .content_wrapper .info_form {
    padding-left: 10px;
    padding-bottom: 10px;
    padding-right: 10px;
    width: 800px;
    /* border-bottom: 1px solid #eeeeee; */
    overflow-y: auto;
  }

  .devInfo   .content_wrapper  .info{
    height: 40px;
    font-size: 14px;
    /* font-weight: bold; */
    text-align: center;
    line-height: 40px;
    vertical-align: middle;
  }
  .devInfo .content_wrapper .info div{
    display: inline-block;
  }
  .devInfo .content_wrapper .info  .info_label{
    width: 30%;
    float: left;
    text-align: right;
  }
  .devInfo   .content_wrapper .info .info_content{
    padding-left: 15px;
    text-align: left;
    float: left;
  }
  .devInfo .content__wrapper .companyInfo .el-input{
    width: 80%;
  }
  .devInfo img.businessLicense{
    height: 40px;
    line-height: 40px;
    width: 40px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    cursor: pointer;
  }

</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/add-developer/modify.vue